export default __webpack_public_path__ + "static/media/main-clip.96359232.svg";